import {
  Avatar,
  Button,
  Card,
  Col,
  Form,
  Image,
  Input,
  Row,
  Select,
  Skeleton,
  Space,
  Switch,
} from "antd";
import axios from "axios";
import { debounce } from "lodash";
import PropTypes from "prop-types";
import React, { useCallback, useEffect, useRef, useState } from "react";
import { authenticateToken } from "../../utils/auth";
import { responseNotification } from "../../utils/notify";
import { jcTypeArray } from "../../utils";
import { getImgUrl } from "../../utils/index";
import {
  CloseOutlined,
  LeftCircleOutlined,
  MinusCircleOutlined,
  PlusOutlined,
} from "@ant-design/icons";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { Link, useHistory, useParams } from "react-router-dom";
import ImageUploader from "../FileManager/upload";
const { Option } = Select;

interface AddProductProps {
  productBarcode?: any;
  onCloseMethod?: () => void;
}

const AddGlobalProduct = (props: AddProductProps) => {
  const history = useHistory();
  const route = useParams();
  const [visible, setVisible] = useState(false);
  const [type, setType] = useState<string>("");
  const { productBarcode } = props;
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [isActive, setIsActive] = useState<boolean>();
  const [imageUrls, setImageUrls] = useState<string[]>([]);
  const [thumbImageUrl, setThumbImageUrl] = useState<string>();
  const [variationImageUrl, setVariationImageUrl] = useState<string[]>([]);
  const [generatedImgUrl, setGeneratedImgUrl] = useState<string>();
  const [generatedThumbUrl, setGeneratedThumbUrl] = useState<string>();
  const [updateEveryWhere, setUpdateEveryWhere] = useState<boolean>();
  const [convertedText, setConvertedText] = useState("");

  const [startUpload, setStartUpload] = useState<
    "Initiated" | "Uploading" | "Uploaded"
  >(undefined);

  const [startUpload2, setStartUpload2] = useState<
    "Initiated" | "Uploading" | "Uploaded"
  >(undefined);

  const [singleProductInfo, setSingleProductInfo] = useState({
    loading: false,
    data: null,
  });

  const [brandsOptions, setBrandsOptions] = useState<any>({
    list: [],
    loading: false,
  });

  const [categoriesOptions, setCategoriesOptions] = useState<any>({
    list: [],
    loading: false,
  });

  const onSubmit = useCallback(
    async (data) => {
      if (generatedImgUrl || generatedThumbUrl) {
        setLoading(true);
        let readyData = data && {
          isUpdateEveryWhere: updateEveryWhere,
          barCode: data.barCode,
          sku: data.sku,
          name: data.name,
          type: type,
          categoryId: data.categoryId,
          brandId: data.brandId,
          campaignId: data.campaignId,
          keyword: data.keyword,
          isPopular: data.isPopular,
          description: convertedText || "<p></p>",
          productImage:
            generatedThumbUrl || singleProductInfo?.data?.productImage,
          images: generatedImgUrl
            ? generatedImgUrl
            : singleProductInfo?.data?.images,
          isActive: isActive,
          variations: data?.variations?.map((variant, i) => ({
            variationName: variant.variationName,
            variationId: variant.variationId,
            imageUrl: variant.imageUrl,
            barCode: variant.barCode || data.barCode,
            regularVariationId: data?.variations?.[i + 1]?.variationId,
            maximumOrderLimit: variant.maximumOrderLimit
              ? parseInt(variant.maximumOrderLimit)
              : undefined,
            price: {
              mrp: parseFloat(variant.mrp) * 1,
              tp: parseFloat(variant.tp) * 1,
            },
            productDiscount: {
              flat: parseFloat(variant.flat) || 0,
              percentage: parseFloat(variant.percentage) || 0,
            },
            stock: parseFloat(variant.stock) || 0,
          })),
        };

        if (singleProductInfo?.data) {
          await fetch(
            `${process.env.REACT_APP_CATALOG_WRITER_API}/global-product`,
            {
              method: "PUT",
              headers: {
                Authorization: `Bearer ${authenticateToken()}`,
                "Content-Type": "application/json",
              },
              body: JSON.stringify({
                ...readyData,
                barCode: singleProductInfo?.data?.barCode,
                isActive: isActive,
                // isUpdateEveryWhere: updateEveryWhere,
              }),
            }
          )
            .then((res) => res.json())
            .then((res) => {
              setLoading(false);

              if (res.statusCode === 200) {
                responseNotification("Product Updated Successfully", "success");
                form.resetFields();
                if (history?.length === 1) {
                  history.push(`/products`);
                } else {
                  history?.goBack();
                }
              } else if (res.status === 500) {
                responseNotification("Internal server error", "error");
              } else {
                responseNotification(
                  res.message || "something wrong",
                  "warning"
                );
              }
            })
            .catch((err) => {
              setLoading(false);
              responseNotification(
                `${"Internal server error"} ${err}`,
                "error"
              );
              console.error("err", err);
            });
        } else {
          await fetch(
            `${process.env.REACT_APP_CATALOG_WRITER_API}/global-product`,
            {
              method: "POST",
              headers: {
                Authorization: `Bearer ${authenticateToken()}`,
                "Content-Type": "application/json",
              },
              body: JSON.stringify(readyData),
            }
          )
            .then((res) => res.json())
            .then((res) => {
              setLoading(false);

              if (res.statusCode === 200) {
                responseNotification("Product Create Successfully", "success");
                form.resetFields();

                history?.goBack();
              } else if (res.status === 500) {
                responseNotification("Internal server error", "error");
              } else {
                responseNotification(
                  res.message || "something wrong",
                  "warning"
                );
              }
            })
            .catch((err) => {
              setLoading(false);
              responseNotification(
                `${"Internal server error"} ${err}`,
                "error"
              );
              console.error("err", err);
            });
        }
      } else {
        responseNotification(`Product Thumbnail & Image required`, "error");
      }
    },
    [
      generatedImgUrl,
      generatedThumbUrl,
      type,
      convertedText,
      singleProductInfo?.data,
      isActive,
      updateEveryWhere,
      form,
      history,
    ]
  );

  useEffect(() => {
    if (startUpload === "Uploaded" && startUpload2 === "Uploaded") {
      form?.submit();
    }
  }, [startUpload, startUpload2]);

  const fetchProductDetails = useCallback((getSlug) => {
    if (getSlug) {
      try {
        setSingleProductInfo({ loading: true, data: undefined });
        axios
          .get(
            `${process.env.REACT_APP_CATALOG_READER_API}/global-product/details?slug=${getSlug}`,
            {
              headers: {
                Authorization: `Bearer ${authenticateToken()}`,
                "Content-Type": "application/json",
              },
            }
          )
          .then((data) => {
            if (data.status === 200) {
              setSingleProductInfo({
                loading: false,
                data: data?.data?.product,
              });
              setConvertedText(data?.data?.product?.description || "");
              setVariationImageUrl(
                data?.data?.product?.variations?.map((item) => item?.imageUrl)
              );
              setGeneratedThumbUrl(data?.data?.product?.productImage);
              setGeneratedImgUrl(data?.data?.product?.images?.[0]);
              setIsActive(data?.data?.product?.isActive);
              setType(data?.data?.product?.type);
            } else {
              setSingleProductInfo({ loading: false, data: null });
              responseNotification(
                data.statusText || "something went wrong",
                "error"
              );
            }
          })
          .catch((err) => {
            setSingleProductInfo({ loading: false, data: null });

            console.log(err);
          });
      } catch (error) {
        setSingleProductInfo({ loading: false, data: null });

        console.log(error, "error");
      }
    }
  }, []);

  // **********************************
  // Search Options
  // **********************************

  const getCategoriesOptions = useCallback(
    async (val?: string) => {
      setCategoriesOptions({ loading: true, list: [] });
      const res = await axios.get(
        `${process.env.REACT_APP_CATALOG_READER_API}/admin/category/search?page=0&limit=20&isParent=false` +
          (type ? `&type=${type}` : ``) +
          (val ? `&key=${val}` : ``),
        {
          headers: {
            Authorization: `Bearer ${authenticateToken()}`,
          },
        }
      );

      setCategoriesOptions({
        loading: false,
        list: res?.data?.categories?.map((category) => {
          return {
            id: category?.id,
            title: category?.title,
          };
        }),
      });
    },
    [type]
  );

  const getBrandsOptions = useCallback(
    async (val?: string) => {
      setBrandsOptions({ loading: true, list: [] });

      const res = await axios.get(
        `${process.env.REACT_APP_CATALOG_READER_API}/brand/search?page=0&limit=20` +
          (type ? `&type=${type}` : ``) +
          (val ? `&key=${val}` : ``),

        {
          headers: {
            Authorization: `Bearer ${authenticateToken()}`,
          },
        }
      );

      setBrandsOptions({
        loading: false,
        list: res?.data?.brands?.map((brand) => {
          return {
            id: brand?.id,
            name: brand?.name,
          };
        }),
      });
    },
    [type]
  );
  const fetchRef = useRef(null);

  const handleSearch = React.useMemo(() => {
    const loadOptions = (value: string, field: string) => {
      fetchRef.current += 1;
      const fetchId = fetchRef.current;

      if (fetchId !== fetchRef.current) {
        return;
      }
      if (type) {
        if (value) {
          if (field === "category") getCategoriesOptions(value);
          else if (field === "brand") getBrandsOptions(value);
        }
      } else {
        responseNotification("Select a type before search", "warning");
      }
    };

    return debounce(loadOptions, 800);
  }, [getCategoriesOptions, getBrandsOptions, type]);
  // **********************************
  // Search Options
  // **********************************

  useEffect(() => {
    if (type) {
      getCategoriesOptions();
      getBrandsOptions();
    }
  }, [getBrandsOptions, getCategoriesOptions, type]);

  useEffect(() => {
    fetchProductDetails((route as any).slug);
  }, [fetchProductDetails, route]);

  useEffect(() => {
    if (singleProductInfo?.data) {
      form.resetFields(Object.keys(singleProductInfo?.data));
      setThumbImageUrl(singleProductInfo?.data?.productImage);
      setImageUrls(singleProductInfo?.data?.images || []);
      setVariationImageUrl(
        singleProductInfo?.data?.variations?.map((item) => item?.imageUrl)
      );
      setType(singleProductInfo?.data?.type);
    }
  }, [form, singleProductInfo?.data]);

  const resetData = () => {
    form?.resetFields();
    setImageUrls([]);
    setThumbImageUrl("");
    setVariationImageUrl([]);
    setType("");
    setGeneratedImgUrl(undefined);
    setGeneratedThumbUrl(undefined);
    setStartUpload(undefined);
    setStartUpload2(undefined);
  };

  return (
    <>
      <Row gutter={16} className="min-vh-100">
        {singleProductInfo?.data && (
          <Col span={6}>
            <Card
              cover={
                <div className="product-details-wrapper-content">
                  <div className="show-details-inner-content">
                    <div className="product-image-content_">
                      <div className="product-banner_">
                        <div className="">
                          <Image
                            preview={{ visible: false }}
                            onClick={() => setVisible(true)}
                            src={thumbImageUrl}
                            alt={singleProductInfo?.data?.name}
                          />
                          <div style={{ display: "none" }}>
                            <Image.PreviewGroup
                              preview={{
                                visible,
                                onVisibleChange: (vis) => setVisible(vis),
                              }}
                            >
                              <Image
                                preview={{ visible: false }}
                                onClick={() => setVisible(true)}
                                src={getImgUrl(
                                  singleProductInfo?.data?.productImage
                                )}
                                alt={singleProductInfo?.data?.name}
                                className="rounded"
                              />
                              {singleProductInfo?.data?.images?.length
                                ? singleProductInfo?.data?.images?.map(
                                    (image, index) => (
                                      <Image
                                        src={getImgUrl(image)}
                                        className="rounded"
                                      />
                                    )
                                  )
                                : undefined}
                              {singleProductInfo?.data?.variations?.length
                                ? singleProductInfo?.data?.variations?.map(
                                    (variant, index) => (
                                      <Image
                                        src={variant?.imageUrl}
                                        className="rounded"
                                      />
                                    )
                                  )
                                : undefined}
                            </Image.PreviewGroup>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              }
            >
              <h6>{singleProductInfo?.data?.name}</h6>
            </Card>
          </Col>
        )}

        <Col span={singleProductInfo?.data ? 18 : 24}>
          <Card>
            {singleProductInfo?.loading ? (
              <>
                <Skeleton avatar active paragraph={{ rows: 20 }} />
              </>
            ) : (
              <div className="product-add">
                <div className="">
                  <h3 className="title d-flex align-items-center justify-content-between">
                    <span>
                      <Link
                        to={""}
                        className="mr-2 text-dark"
                        onClick={(e) => {
                          e.preventDefault();
                          history?.goBack();
                        }}
                      >
                        <LeftCircleOutlined />
                      </Link>
                      PRODUCT INFORMATION
                    </span>
                    <div className="">
                      {singleProductInfo?.data && (
                        <Switch
                          checkedChildren="Update All"
                          unCheckedChildren="Single Update"
                          className="mr-3"
                          onChange={(val) => setUpdateEveryWhere(val)}
                        />
                      )}

                      <Link
                        to=""
                        onClick={(e) => {
                          e.preventDefault();
                          history?.goBack();
                        }}
                        className="mr-2 text-dark"
                      >
                        <CloseOutlined />
                      </Link>
                    </div>
                  </h3>

                  <div className="info-body">
                    <div className="add-product drawer-toggle-wrapper">
                      <div className="drawer-toggle-inner-wrapper">
                        <Form
                          name="control-hooks"
                          labelCol={{ span: 24 }}
                          wrapperCol={{ span: 24 }}
                          className="ant-form ant-form-vertical"
                          onFinish={onSubmit}
                          initialValues={{
                            ...singleProductInfo?.data,
                            // type: type,
                          }}
                          form={form} // like ref
                          layout="vertical"
                          autoComplete="off"
                        >
                          <Form.Item
                            hasFeedback
                            label="Type"
                            rules={[
                              {
                                required: true,
                                message: "Type is required!",
                              },
                            ]}
                            name="type"
                          >
                            <Select
                              placeholder="Type"
                              onChange={(val) => {
                                form.resetFields(["categoryId", "brandId"]);
                                setType(val);
                              }}
                            >
                              {Object.values(jcTypeArray)?.map((type, i) => (
                                <Select.Option value={type} key={i}>
                                  {type?.replace("_", " ")}
                                </Select.Option>
                              ))}
                            </Select>
                          </Form.Item>

                          <Form.Item
                            hasFeedback
                            label="Product Barcode"
                            name="barCode"
                            rules={[
                              {
                                required: true,
                                message: "Barcode is Required!",
                              },
                            ]}
                          >
                            <Input
                              id="barCode"
                              type="text"
                              placeholder="Scan Barcode"
                              disabled={updateEveryWhere}
                            />
                          </Form.Item>

                          <Form.Item hasFeedback label="SKU" name="sku">
                            <Input
                              id="sku"
                              type="text"
                              placeholder="Enter SKU"
                            />
                          </Form.Item>

                          <Form.Item
                            hasFeedback
                            label="Product Name"
                            rules={[
                              {
                                required: true,
                                message: "Product Name is Required!",
                              },
                            ]}
                            name="name"
                          >
                            <Input
                              id="name"
                              type="text"
                              placeholder="Enter Product Name"
                            />
                          </Form.Item>

                          <Form.Item
                            hasFeedback
                            label={`Category (${singleProductInfo?.data?.category?.title})`}
                            rules={[
                              {
                                required: true,
                                message: "Category is required!",
                              },
                            ]}
                            name="categoryId"
                          >
                            <Select
                              allowClear
                              showSearch
                              placeholder="Select Category"
                              optionFilterProp="children"
                              // onChange={(val) => setCategoryId(val)}
                              onSearch={(val) => {
                                handleSearch?.(val, "category");
                              }}
                              filterOption={(input, option) =>
                                option.children
                                  .toString()
                                  .toLowerCase()
                                  .indexOf(input.toLowerCase()) >= 0
                              }
                            >
                              {categoriesOptions?.list?.map((category) => (
                                <Option value={category?.id}>
                                  {category?.title}
                                </Option>
                              ))}
                            </Select>
                          </Form.Item>

                          <Form.Item
                            hasFeedback
                            label={`Brand (${singleProductInfo?.data?.brand?.name})`}
                            name="brandId"
                          >
                            <Select
                              allowClear
                              showSearch
                              placeholder="Select Brand"
                              optionFilterProp="children"
                              // onChange={(val) => setBrandId(val)}
                              onSearch={(val) => {
                                handleSearch(val, "brand");
                              }}
                              filterOption={(input, option) =>
                                option.children
                                  .toString()
                                  .toLowerCase()
                                  .indexOf(input.toLowerCase()) >= 0
                              }
                            >
                              {brandsOptions?.list?.map((brand) => (
                                <Option value={brand.id}>{brand.name}</Option>
                              ))}
                            </Select>
                          </Form.Item>

                          <Form.Item
                            hasFeedback
                            label="Keywords"
                            rules={[
                              {
                                required: true,
                                message: "Keywords is Required!",
                              },
                            ]}
                            name="keyword"
                          >
                            <Input
                              id="keyword"
                              type="text"
                              placeholder="Enter Product Keywords"
                            />
                          </Form.Item>

                          <h4 className="title">Product Details</h4>
                          <ReactQuill
                            theme="snow"
                            value={convertedText}
                            onChange={setConvertedText}
                            style={{
                              minHeight: "200px",
                              width: "100%",
                              marginBottom: 60,
                            }}
                          />
                          <Form.Item
                            hasFeedback
                            label="Product Status (Active/Inactive)"
                            name="isActive"
                          >
                            <Switch
                              checkedChildren="Active"
                              unCheckedChildren="Inactive"
                              defaultChecked={
                                (singleProductInfo as any)?.data?.isActive
                              }
                              onChange={(val) => {
                                setIsActive(val);
                              }}
                            />
                          </Form.Item>

                          <Form.Item
                            hasFeedback
                            label="Show as Popular Product?"
                            name="isPopular"
                          >
                            <Switch
                              checkedChildren="Active"
                              unCheckedChildren="Inactive"
                              defaultChecked={
                                (singleProductInfo as any)?.data?.isPopular
                              }
                            />
                          </Form.Item>
                          {!updateEveryWhere && (
                            <>
                              <h4 className="title" style={{ minWidth: "98%" }}>
                                Product Variations
                              </h4>
                              <Form.List
                                name="variations"
                                rules={[
                                  {
                                    validator: async (_, names) => {
                                      if (!names || names.length < 1) {
                                        return Promise.reject(
                                          new Error(
                                            "At least 1 variation required!"
                                          )
                                        );
                                      }
                                    },
                                  },
                                ]}
                              >
                                {(fields, { add, remove }, { errors }) => (
                                  <>
                                    {fields.map(
                                      ({
                                        key,
                                        name,
                                        fieldKey,
                                        ...restField
                                      }: any) => (
                                        <Space wrap key={key} align="center">
                                          {variationImageUrl && (
                                            <div>
                                              <Avatar
                                                src={variationImageUrl[name]}
                                                shape="square"
                                                size="large"
                                              />
                                            </div>
                                          )}
                                          <Form.Item
                                            {...restField}
                                            name={[name, "imageUrl"]}
                                            fieldKey={[fieldKey, "imageUrl"]}
                                            label="Image"
                                            style={{ width: 100 }}
                                            initialValue={
                                              singleProductInfo?.data
                                                ?.variations?.[name]?.imageUrl
                                            }
                                          >
                                            <Input
                                              placeholder="Enter Image"
                                              onChange={async (e) => {
                                                setVariationImageUrl((prev) => {
                                                  const newArr =
                                                    Array.from(prev);
                                                  newArr[name] = e.target.value;
                                                  return newArr;
                                                });
                                              }}
                                            />
                                          </Form.Item>

                                          <Form.Item
                                            {...restField}
                                            name={[name, "variationId"]}
                                            fieldKey={[fieldKey, "variationId"]}
                                            label="ID"
                                            style={{ width: 80 }}
                                            initialValue={
                                              singleProductInfo?.data
                                                ?.variations?.[name]
                                                ?.variationId
                                            }
                                          >
                                            <Input
                                              id="variationId"
                                              placeholder="Enter ID"
                                              disabled={singleProductInfo?.data}
                                            />
                                          </Form.Item>

                                          <Form.Item
                                            {...restField}
                                            name={[name, "barCode"]}
                                            fieldKey={[fieldKey, "barCode"]}
                                            label="Barcode"
                                            style={{ width: 100 }}
                                            initialValue={
                                              singleProductInfo?.data
                                                ?.variations?.[name]?.barCode
                                            }
                                          >
                                            <Input placeholder="Enter Barcode" />
                                          </Form.Item>

                                          <Form.Item
                                            {...restField}
                                            name={[name, "variationName"]}
                                            fieldKey={[
                                              fieldKey,
                                              "variationName",
                                            ]}
                                            label="Name"
                                            rules={[
                                              {
                                                required: true,
                                                message: "Required!",
                                              },
                                            ]}
                                            style={{ width: 120 }}
                                            initialValue={
                                              singleProductInfo?.data
                                                ?.variations?.[name]
                                                ?.variationName
                                            }
                                          >
                                            <Input placeholder="Enter title" />
                                          </Form.Item>

                                          <Form.Item
                                            {...restField}
                                            name={[name, "mrp"]}
                                            fieldKey={[fieldKey, "mrp"]}
                                            label="MRP"
                                            style={{ width: 80 }}
                                            rules={[
                                              {
                                                required: true,
                                                message: "Required!",
                                              },
                                            ]}
                                            initialValue={
                                              singleProductInfo?.data
                                                ?.variations?.[name]?.price?.mrp
                                            }
                                          >
                                            <Input placeholder="Enter MRP" />
                                          </Form.Item>

                                          <Form.Item
                                            {...restField}
                                            name={[name, "tp"]}
                                            fieldKey={[fieldKey, "tp"]}
                                            label="TP"
                                            style={{ width: 80 }}
                                            rules={[
                                              {
                                                required: true,
                                                message: "Required!",
                                              },
                                            ]}
                                            initialValue={
                                              singleProductInfo?.data
                                                ?.variations?.[name]?.price?.tp
                                            }
                                          >
                                            <Input placeholder="Enter TP" />
                                          </Form.Item>

                                          <Form.Item
                                            {...restField}
                                            name={[name, "flat"]}
                                            fieldKey={[fieldKey, "flat"]}
                                            initialValue={
                                              singleProductInfo?.data
                                                ?.variations?.[name]
                                                ?.productDiscount?.flat
                                            }
                                            label="Flat Discount"
                                            style={{ width: 100 }}
                                          >
                                            <Input placeholder="Flat Discount (Tk.)" />
                                          </Form.Item>

                                          <Form.Item
                                            {...restField}
                                            name={[name, "percentage"]}
                                            fieldKey={[fieldKey, "percentage"]}
                                            label="Percent Discount"
                                            initialValue={
                                              singleProductInfo?.data
                                                ?.variations?.[name]
                                                ?.productDiscount?.percentage
                                            }
                                            style={{ width: 125 }}
                                          >
                                            <Input placeholder="% Discount 00.00" />
                                          </Form.Item>

                                          <Form.Item
                                            {...restField}
                                            name={[name, "maximumOrderLimit"]}
                                            fieldKey={[
                                              fieldKey,
                                              "maximumOrderLimit",
                                            ]}
                                            label="Max Order Limit"
                                            initialValue={
                                              singleProductInfo?.data
                                                ?.variations?.[name]
                                                ?.maximumOrderLimit
                                            }
                                            style={{ width: 130 }}
                                          >
                                            <Input placeholder="Maximum Order Limit" />
                                          </Form.Item>

                                          <Form.Item
                                            {...restField}
                                            name={[name, "stock"]}
                                            fieldKey={[fieldKey, "stock"]}
                                            label="Stock"
                                            initialValue={
                                              singleProductInfo?.data
                                                ?.variations?.[name]?.stock
                                            }
                                            rules={[
                                              {
                                                required: true,
                                                message: "Required!",
                                              },
                                            ]}
                                            style={{ width: 80 }}
                                          >
                                            <Input placeholder="Stock" />
                                          </Form.Item>

                                          {/* <Form.Item
                                        {...restField}
                                        name={[name, "freeProductId"]}
                                        fieldKey={[fieldKey, "freeProductId"]}
                                        hasFeedback
                                        label="Free Product"
                                        initialValue={
                                          singleProductInfo?.data?.variations?.[
                                            name
                                          ]?.quantitativeProductDiscount
                                            ?.freeProductId
                                        }
                                        style={{ width: 150 }}
                                      >
                                        <Input placeholder="Free Product" />
                                      </Form.Item>

                                      <Form.Item
                                        {...restField}
                                        name={[name, "minimumQuantity"]}
                                        fieldKey={[fieldKey, "minimumQuantity"]}
                                        hasFeedback
                                        label="Minimum Quantity"
                                        initialValue={
                                          singleProductInfo?.data?.variations?.[
                                            name
                                          ]?.quantitativeProductDiscount
                                            ?.minimumQuantity
                                        }
                                        style={{ width: 150 }}
                                      >
                                        <Input placeholder="Minimum Quantity" />
                                      </Form.Item>

                                      <Form.Item
                                        {...restField}
                                        name={[name, "flat"]}
                                        fieldKey={[fieldKey, "flat"]}
                                        hasFeedback
                                        label="Product Discount in Flat"
                                        initialValue={
                                          singleProductInfo?.data?.variations?.[
                                            name
                                          ]?.quantitativeProductDiscount
                                            ?.productDiscount?.flat
                                        }
                                        style={{ width: 150 }}
                                      >
                                        <Input placeholder="Product Discount in Flat" />
                                      </Form.Item>

                                      <Form.Item
                                        {...restField}
                                        name={[name, "percentage"]}
                                        fieldKey={[fieldKey, "percentage"]}
                                        hasFeedback
                                        label="Product Discount in percentage"
                                        initialValue={
                                          singleProductInfo?.data?.variations?.[
                                            name
                                          ]?.quantitativeProductDiscount
                                            ?.productDiscount?.percentage
                                        }
                                        style={{ width: 150 }}
                                      >
                                        <Input placeholder="Product Discount in percentage" />
                                      </Form.Item> */}

                                          <MinusCircleOutlined
                                            onClick={() => {
                                              remove(name);
                                              setVariationImageUrl((prev) => {
                                                const newArr = prev.filter(
                                                  (_, i) => i !== name
                                                );
                                                return newArr;
                                              });
                                            }}
                                            style={{ color: "#e62d26" }}
                                          />
                                        </Space>
                                      )
                                    )}

                                    <Form.Item
                                      style={{
                                        width: "100%",
                                        flex: "1 1 100%",
                                        marginBottom: 5,
                                      }}
                                    >
                                      <Button
                                        type="dashed"
                                        onClick={() => {
                                          add();
                                          setVariationImageUrl((prev) => {
                                            const newArr = Array.from(prev);
                                            newArr.push("");
                                            return newArr;
                                          });
                                        }}
                                        block
                                        icon={<PlusOutlined />}
                                        // danger
                                      >
                                        Add Variation
                                      </Button>
                                    </Form.Item>

                                    <Form.ErrorList errors={errors} />
                                  </>
                                )}
                              </Form.List>
                            </>
                          )}

                          <h4 className="title">Product Images</h4>
                          <div className="d-flex">
                            <div className="mr-4">
                              <p className="mb-1">Thumbnail</p>
                              <ImageUploader
                                crop={1.26}
                                imgUrl={generatedThumbUrl || ""}
                                startUpload={startUpload}
                                setStartUpload={(val) => setStartUpload(val)}
                                setGeneratedImgUrl={(url) =>
                                  setGeneratedThumbUrl(url)
                                }
                              />
                            </div>
                            <div className="">
                              <p className="mb-1">Images:</p>
                              <ImageUploader
                                // crop={1.26}
                                multiple
                                imgUrl={imageUrls || []}
                                startUpload={startUpload}
                                setStartUpload={(val) => setStartUpload2(val)}
                                setGeneratedImgUrl={(url) =>
                                  setGeneratedImgUrl(url)
                                }
                              />
                            </div>
                          </div>
                          {/* <div
                            className="mb-4 __d-flex-l"
                            style={{
                              minWidth: "100%",
                              alignItems: "center",
                              justifyContent: "space-between",
                            }}
                          >
                            <Form.Item
                              name="productImage"
                              label="Thumbnail"
                              style={{ maxWidth: "98%" }}
                              validateTrigger={["onChange", "onBlur"]}
                              rules={[
                                {
                                  required: true,
                                  message: "Product Image Url is required",
                                },
                                {
                                  // @ts-ignore
                                  type: "url",
                                  warningOnly: true,
                                  message: "Enter valid url",
                                },
                              ]}
                            >
                              <Input
                                placeholder="Enter Image Url"
                                onChange={async (e) => {
                                  setThumbImageUrl(e.target.value);
                                }}
                              />
                            </Form.Item>
                          </div>

                          <Form.List
                            name="images"
                            rules={[
                              {
                                validator: async (_, names) => {
                                  if (!names || names.length < 1) {
                                    return Promise.reject(
                                      new Error(
                                        "At least 1 image url required!"
                                      )
                                    );
                                  }
                                },
                              },
                            ]}
                          >
                            {(fields, { add, remove }, { errors }) => (
                              <>
                                {fields.map((field, index) => (
                                  <Form.Item
                                    required={true}
                                    key={field.key}
                                    label={index === 0 ? "Images" : undefined}
                                    style={{
                                      flex: "1 1 100%",
                                    }}
                                    initialValue={
                                      singleProductInfo?.data?.images?.[index]
                                        ?.url
                                    }
                                  >
                                    <Form.Item
                                      {...field}
                                      validateTrigger={["onChange", "onBlur"]}
                                      rules={[
                                        {
                                          required: true,
                                          message:
                                            "Product Image Url is required",
                                        },
                                        {
                                          // @ts-ignore
                                          type: "url",
                                          warningOnly: true,
                                          message: "Enter valid url",
                                        },
                                      ]}
                                      noStyle
                                      initialValue={
                                        singleProductInfo?.data?.images?.[index]
                                          ?.url
                                      }
                                    >
                                      <Input
                                        placeholder="Enter Image Url"
                                        onChange={(e) => {
                                          const addedUrls =
                                            Array.from(imageUrls);
                                          addedUrls[field.name] =
                                            e.target.value;
                                          setImageUrls(addedUrls);
                                        }}
                                      />
                                    </Form.Item>

                                    <MinusCircleOutlined
                                      className="dynamic-delete-button"
                                      onClick={() => {
                                        remove(field.name);
                                        const addedUrls = imageUrls.filter(
                                          (_, index) => index !== field.name
                                        );
                                        setImageUrls(addedUrls);
                                      }}
                                      style={{
                                        color: "#e62d26",
                                        marginLeft: 15,
                                      }}
                                    />
                                  </Form.Item>
                                ))}
                                <Form.Item
                                  style={{
                                    width: "100%",
                                    flex: "1 1 100%",
                                    marginBottom: 5,
                                  }}
                                >
                                  <Button
                                    type="dashed"
                                    onClick={() => {
                                      add();
                                      const addedUrls = Array.from(imageUrls);
                                      addedUrls.push("");
                                      setImageUrls(addedUrls);
                                    }}
                                    style={{ width: "40%" }}
                                    icon={<PlusOutlined />}
                                  >
                                    Add Image
                                  </Button>
                                </Form.Item>
                                <Form.ErrorList errors={errors} />
                              </>
                            )}
                          </Form.List>
                          <div
                            className="mt-4 d-flex-l"
                            style={{ minWidth: "100%" }}
                            id="imgTh"
                          >
                            <div className="mr-2">
                              {thumbImageUrl && (
                                <Image
                                  src={thumbImageUrl}
                                  height={150}
                                  className="img img-thumbnail"
                                />
                              )}
                            </div>

                            {imageUrls?.filter((item) => item).length
                              ? imageUrls.map(
                                  (imgUrl) =>
                                    imgUrl && (
                                      <div className="mr-2">
                                        <Image
                                          src={imgUrl}
                                          height={150}
                                          className="img img-thumbnail"
                                        />
                                      </div>
                                    )
                                )
                              : undefined}
                          </div> */}

                          <div className="buttons-container">
                            <Button
                              disabled={
                                loading ||
                                startUpload === "Uploading" ||
                                startUpload2 === "Uploading"
                              }
                              loading={
                                loading ||
                                startUpload === "Uploading" ||
                                startUpload2 === "Uploading"
                              }
                              type="primary"
                              htmlType="submit"
                              className="add-submit-btn text-center mr-2"
                              onClick={(e) => {
                                e.preventDefault();
                                // if (startUpload === "Initiated")  setStartUpload("Uploading");
                                // if(startUpload2 === "Initiated") setStartUpload2("Uploading");
                                setStartUpload("Uploading");
                                setStartUpload2("Uploading");
                              }}
                            >
                              {updateEveryWhere
                                ? "Update Everywhere"
                                : "Submit"}
                            </Button>
                            <Button
                              type="ghost"
                              htmlType="button"
                              onClick={resetData}
                              className="reset-submit-btn text-center mr-2"
                            >
                              Reset
                            </Button>
                          </div>
                        </Form>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </Card>
        </Col>
      </Row>
    </>
  );
};
AddGlobalProduct.propTypes = {
  visibleData: PropTypes.any,
  onCloseMethod: PropTypes.func,
};

export default AddGlobalProduct;
